.coverPage {
    margin: 20px;
}
.coverPage .links {
    list-style-type: square;
}
.coverPage .links li {
    line-height: 2;
}
.coverPage .links li a {
    font-size: 1.424em;
    font-weight: bold;
    color: #378893;
}
.coverPage .links li a:hover {
    color: #62c2c2;
}
